import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get language display name
  const getLanguageDisplay = (code) => {
    switch(code) {
      case 'ru':
        return 'RU';
      case 'ro':
        return 'RO';
      case 'en':
        return 'EN';
      default:
        return code.toUpperCase();
    }
  };

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <div 
        className={`current-language ${isOpen ? 'active' : ''}`} 
        onClick={toggleDropdown}
      >
        {getLanguageDisplay(i18n.language)}
      </div>
      
      {isOpen && (
        <div className="language-menu">
          <button 
            className={`language-btn ${i18n.language === 'ru' ? 'active' : ''}`} 
            onClick={() => changeLanguage('ru')}
          >
            RU
          </button>
          <button 
            className={`language-btn ${i18n.language === 'ro' ? 'active' : ''}`} 
            onClick={() => changeLanguage('ro')}
          >
            RO
          </button>
          <button 
            className={`language-btn ${i18n.language === 'en' ? 'active' : ''}`} 
            onClick={() => changeLanguage('en')}
          >
            EN
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
